import { render, staticRenderFns } from "./TransactionInputTable.vue?vue&type=template&id=eb51aeb2&"
import script from "./TransactionInputTable.vue?vue&type=script&lang=js&"
export * from "./TransactionInputTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionInputTable.vue?vue&type=style&index=0&id=eb51aeb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VSpacer})
